export const prepareTemplatePayload = (
  data,
  marketerParameters,
  marketerParametersSecondary,
  selections
) => {
  const marketer_data = Object.fromEntries(
    marketerParameters
      .concat(marketerParametersSecondary)
      .flatMap(({ name, values }) =>
        values.length === 1 ? [[name, values[0]]] : []
      )
  );
  return {
    ...data,
    client_data: data.client_data[0],
    marketer_data,
    marketer_data_selection: selections,
  };
};
